<template>
  <div style="margin: 20px">
    <v-card>
      <v-toolbar dense color="primary" dark align="center">
        <v-row>
          <v-col cols="5" align="left">
            <v-toolbar-title>Gestione Moduli Menu</v-toolbar-title>
          </v-col>
          <v-col cols="2">
            <v-btn small light @click="save" :disabled="azienda_sel < 0 || !azienda_sel">
              <v-icon color="success">mdi-floppy</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="4" align="right">
            <v-btn small light @click="getAziende">
              <v-icon color="primary">mdi-autorenew</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="1" align="right">
            <v-btn small light @click="$router.push('/home/amministrazione')">
              <v-icon color="error">mdi-keyboard-backspace</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-toolbar>
      <v-card-text style="max-height: 80vh; overflow-y: scroll">
        <v-container>
          <v-row align="center">
            <v-col cols="4" />
            <v-col cols="4">
              <v-autocomplete
                :items="aziende"
                item-text="ragione_sociale"
                item-value="id_azienda"
                solo
                label="Seleziona Azienda"
                v-model="azienda_sel"
                @change="getModuli"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <main id="tree_view" v-if="loaded == true">
            <section
              v-for="menu_tree in array_menu_tree"
              :key="menu_tree.cod_modulo"
              class="flex-nowrap"
            >
              <v-row no-gutters class="flex-nowrap">
                <v-col cols="auto">
                  <v-treeview :items="menu_tree">
                    <!-- Icona menù -->
                    <template v-slot:prepend="{ item }">
                      <v-icon
                        v-if="item.is_modulo == false"
                        @click="clickEditModulo(item, false)"
                      >
                        {{ item.icon }}
                      </v-icon>
                    </template>

                    <!-- Testo menù -->
                    <template v-slot:label="{ item }">
                      <a
                        v-if="item.is_modulo == false"
                        @click="clickEditModulo(item, false)"
                      >
                        {{ item.des }}
                      </a>
                      <h4 v-else>
                        {{ item.des }}
                      </h4>
                    </template>

                    <!-- Icona aggiungi -->
                    <template v-slot:append="{ item }">
                      <v-icon @click="clickEditModulo(item, true)">
                        mdi-plus
                      </v-icon>
                      <v-icon @click="clickDeleteModulo(item)">
                        {{
                          item.validita == 0
                            ? "mdi-delete-restore"
                            : "mdi-delete"
                        }}
                      </v-icon>
                    </template>
                  </v-treeview>
                </v-col>
              </v-row>
            </section>
          </main>
        </v-container>
      </v-card-text>
    </v-card>
    <!-- SNACKBAR -->
    <v-snackbar
      style="position: fixed; bottom: 10px"
      dark
      :color="alert.error == true ? 'error' : 'light-green darken-2'"
      v-model="alert.show"
    >
      {{ alert.message }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="alert.show = false">Chiudi</v-btn>
      </template>
    </v-snackbar>
    <!-- Dialog MODULI MENU DETAIL-->
    <v-dialog persistent v-model="dialog_moduli_menu">
      <v-card>
        <v-toolbar color="primary" dense dark>
          <v-row align="center">
            <v-col cols="5" align="left">
              <v-toolbar-title>{{
                template_menu.id_modulo_menu === -1
                  ? "Aggiungi Modulo"
                  : "Modifica Modulo"
              }}</v-toolbar-title>
            </v-col>
            <v-col cols="2">
              <v-btn small @click="clickSaveModulo" light>
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="5" align="right">
              <v-btn small @click="dialog_moduli_menu = false" light>
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>
        <v-card-text class="pl-5 pr-5 pt-5 pb-5">
          <v-row>
            <v-col cols="3">
              <v-text-field
                hide-details
                dense
                v-model="template_menu.des"
                label="Descrizione"
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                hide-details
                dense
                v-model="template_menu.icon"
                label="Icona"
                :prepend-icon="
                  template_menu.icon == null
                    ? 'mdi-image-off'
                    : template_menu.icon
                "
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                hide-details
                dense
                v-model="template_menu.text"
                label="Nome"
              />
            </v-col>
            <v-col cols="3">
              <v-row>
                <v-col :cols="is_nuovo_modulo_menu == true ? 7 : 12" v-if="template_menu.path != ''" class="pr-0">
                  <v-text-field
                    hide-details
                    dense
                    v-model="template_menu.path"
                    :label="is_nuovo_modulo_menu == true ? '' : 'Percorso'"
                    readonly
                    
                  />
                </v-col>
                <v-col :cols="template_menu.path != '' ? 5 : 12" v-if="is_nuovo_modulo_menu == true" class="pl-0">
                  <v-text-field
                    hide-details
                    dense
                    v-model="template_menu_path"
                    label="Percorso"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row align="center" justify="start">
            <v-col cols="3">
              <v-text-field
                hide-details
                dense
                v-model="template_menu.link_menu"
                label="Link Menu"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-checkbox
                :false-value="0"
                :true-value="1"
                v-model="template_menu.form_startup"
                label="Form Startup"
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                hide-details
                dense
                v-model="template_menu.pagina"
                label="Ordine"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                hide-details
                dense
                v-model="template_menu.cod_menu"
                label="Cod. Menu"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col cols="12" sm="12" md="12">
              <template>
                <!-- Data table dei parametri del modulo -->
                <v-data-table
                  :headers="headers_param_menu"
                  :items="filteredParametriValidita"
                  hide-default-footer
                  :items-per-page="12000"
                  class="elevation-1"
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-app-bar-nav-icon></v-app-bar-nav-icon>
                      <v-toolbar-title>Parametri Modulo</v-toolbar-title>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-spacer></v-spacer>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            small
                            v-bind="attrs"
                            v-on="on"
                            @click="nuovo_parametro"
                          >
                            <v-icon color="blue"
                              >mdi mdi-file-plus-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Nuovo Parametro</span>
                      </v-tooltip>
                    </v-toolbar>
                  </template>
                  <template v-slot:[`item.cod_parametro`]="{ item }">
                    <v-text-field v-model="item.cod_parametro"></v-text-field>
                  </template>
                  <template v-slot:[`item.val_parametro`]="{ item }">
                    <v-text-field v-model="item.val_parametro"></v-text-field>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="deleteItem(item)"
                        >
                          <v-icon color="purple">mdi-delete-outline </v-icon>
                        </v-btn>
                      </template>
                      <span>Elimina Parametro </span>
                    </v-tooltip>
                  </template>
                  <template v-slot:no-data>
                    <v-btn color="primary" @click="nuovo_parametro">
                      Nuovo
                    </v-btn>
                  </template>
                </v-data-table>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment/moment";

export default {
  name: "GestioneModuliMenu",
  components: {},
  data() {
    return {
      alert: {
        show: false,
        message: null,
        error: false,
      },
      aziende: [],
      azienda_sel: -1,
      moduli: [],
      loaded: false,
      NETWORK: null,

      modulo_menu_selez: null,
      dialog_moduli_menu: false,

      template_menu_path: "",

      // gestione tree
      array_menu_tree: [],

      // Moduli Menu Detail
      template_menu_default: {
        id_modulo_menu: -1,
        id_modulo: null,
        id_modulo_menu_rif: null,
        id_temp_padre: null,
        id_temp: null,
        des: null,
        icon: null,
        text: null,
        path: null,
        cod_menu: null,
        link_menu: null,
        children: [],
        moduli_menu_parametri: [],
        form_startup: null,
        pagina: null,
        id_utente: null,
        validita: 1,
        is_modulo: false,
      },

      template_menu: {
        id_modulo_menu: -1,
        id_modulo: null,
        id_modulo_menu_rif: null,
        id_temp_padre: null,
        id_temp: null,
        des: null,
        icon: null,
        text: null,
        path: null,
        cod_menu: null,
        link_menu: null,
        children: [],
        moduli_menu_parametri: [],
        form_startup: null,
        pagina: null,
        id_utente: null,
        validita: 1,
        is_modulo: false,
      },

      headers_param_menu: [
        { text: "Parametro", value: "cod_parametro", sortable: false },
        { text: "Valore", value: "val_parametro", sortable: false },
        { text: "", value: "actions", width: "8%", sortable: false },
      ],

      // Modali
      is_nuovo_modulo_menu: false,
    };
  },

  mounted() {
    this.NETWORK = this.$store.state.Network;
    this.getAziende();
  },

  methods: {
    clickDeleteModulo(item) {
      this.modulo_menu_selez = item;
      this.modulo_menu_selez.validita = !this.modulo_menu_selez.validita;
    },

    clickEditModulo(item, nuovo) {
      this.modulo_menu_selez = item;
      this.is_nuovo_modulo_menu = nuovo;
      if (nuovo == true) {
        this.template_menu = JSON.parse(
          JSON.stringify(this.template_menu_default)
        );
        this.template_menu.id_temp_padre = item.id_temp;
        this.template_menu.id_temp = -moment().valueOf();
        this.template_menu.id_modulo = item.id_modulo;
        this.template_menu.path = item.path ? (item.path + "/") : "";
      } else this.template_menu = JSON.parse(JSON.stringify(item));
      this.dialog_moduli_menu = true;
    },

    clickSaveModulo() {
      if (this.is_nuovo_modulo_menu == true) {
        this.template_menu.path =
          this.template_menu.path + this.template_menu_path;
        this.modulo_menu_selez.children.push(
          JSON.parse(JSON.stringify(this.template_menu))
        );
      } else {
        this.modulo_menu_selez.des = this.template_menu.des;
        this.modulo_menu_selez.icon = this.template_menu.icon;
        this.modulo_menu_selez.text = this.template_menu.text;
        this.modulo_menu_selez.path = this.template_menu.path;
        this.modulo_menu_selez.link_menu = this.template_menu.link_menu;
        this.modulo_menu_selez.moduli_menu_parametri =
          this.template_menu.moduli_menu_parametri;
        this.modulo_menu_selez.form_startup = this.template_menu.form_startup;
        this.modulo_menu_selez.pagina = this.template_menu.pagina;
        this.modulo_menu_selez.cod_menu = this.template_menu.cod_menu;
      }
      this.dialog_moduli_menu = false;
    },

    async setTree() {
      this.array_menu_tree = [];
      // Ricostruisci l'albero.
      for (let i = 0; i < this.moduli.length; i++) {
        let menu_tree = [];
        menu_tree.push(JSON.parse(JSON.stringify(this.moduli[i])));
        menu_tree[0].des =
          menu_tree[0].text =
          menu_tree[0].des =
            menu_tree[0].des_modulo;
        menu_tree[0].is_modulo = true;
        menu_tree[0].children = [];
        if (this.moduli[i].moduli_menu.length > 0)
          await this.buildTree(
            this.moduli[i].moduli_menu,
            menu_tree[0].children,
            "",
            true
          );
        this.array_menu_tree.push(menu_tree);
      }
    },

    async buildTree(arg, tree, path, root = false) {
      var done = true;
      var lev = path.split("/").length;

      if (root == true) {
        tree.push(JSON.parse(JSON.stringify(arg[0])));
        tree[tree.length - 1].children = [];
        tree[tree.length - 1].is_modulo = false;
        await this.buildTree(arg, tree[0].children, "");
      } else {
        arg.forEach((e) => {
          if (e.path.split("/").length > lev) {
            done = false;
          }

          if (e.path.substring(0, e.path.lastIndexOf("/")) == path) {
            tree.push(JSON.parse(JSON.stringify(e)));
            tree[tree.length - 1].children = [];
            tree[tree.length - 1].is_modulo = false;
          }
        });
        if (done == false) {
          for (let i = 0; i < tree.length; i++) {
            await this.buildTree(arg, tree[i].children, tree[i].path);
          }
        }
      }
      return true;
    },

    async revertTree(arg, result) {
      let arg_tmp = JSON.parse(JSON.stringify(arg));
      for (let i = 0; i < arg.length; i++) {
        delete arg_tmp[i].children;
        result.moduli_menu.push(arg_tmp[i]);
        result.moduli_parametri = result.moduli_parametri
          ? result.moduli_parametri
          : [];
        if (arg[i].children.length > 0) {
          await this.revertTree(arg[i].children, result);
        }
      }
      return true;
    },

    getAziende() {
      let that = this;
      let request = {
        controller: "Modulo",
        body: {
          action: "getAzienda",
          token: localStorage.user_token,
        },
        method: "POST",
        on: {
          load: function (response) {
            that.aziende = [];
            that.moduli = [];
            that.azienda_sel = -1;
            that.aziende = response.azienda;
          },
        },
      };
      this.NETWORK.AjaxRequest(request);
    },

    getModuli() {
      this.loaded = false;
      let that = this;
      let request = {
        controller: "Modulo",
        body: {
          action: "getmenuparametri",
          token: localStorage.user_token,
        },
        method: "POST",
        on: {
          load: function (response) {
            that.moduli = [];
            try {
              that.moduli = response.moduli;
              for (let i = 0; i < that.moduli.length; i++) {
                for (let j = 0; j < that.moduli[i].moduli_menu.length; j++) {
                  // that.moduli[i].moduli_menu[j].pagina = j;
                  for (
                    let z = 0;
                    z <
                    that.moduli[i].moduli_menu[j].moduli_menu_parametri.length;
                    z++
                  ) {
                    that.moduli[i].moduli_menu[j].moduli_menu_parametri[
                      z
                    ].id_temp_padre = that.moduli[i].moduli_menu[j].id_temp;
                  }
                }
                that.moduli[i].ordine = i;
                that.moduli[i].moduli_parametri = [];
              }
              if (that.aziende.length > 0) {
                that.getModuliAzienda(that.azienda_sel);
              }
              that.setTree();
            } catch (error) {
              console.log(error);
            }
          },
        },
      };
      this.NETWORK.AjaxRequest(request);
    },

    getModuliAzienda(index_azienda) {
      let that = this;
      let request = {
        controller: "Modulo",
        body: {
          action: "getModuliAzienda",
          token: localStorage.user_token,
          id_azienda: index_azienda,
        },
        method: "POST",
        on: {
          load: function (response) {
            try {
              let moduli_aziende = response.moduli;
              for (let i = 0; i < moduli_aziende.length; i++) {
                let modulo_azienda = moduli_aziende[i];
                for (let i_s = 0; i_s < that.moduli.length; i_s++) {
                  let modulo = that.moduli[i_s];
                  if (modulo.cod_modulo == modulo_azienda.cod_modulo) {
                    that.moduli[i_s].id_modulo = modulo_azienda.id_modulo;
                    //that.moduli[i_s].ordine = modulo_azienda.ordine;
                    for (
                      let j = 0;
                      j < modulo_azienda.moduli_menu.length;
                      j++
                    ) {
                      let modulo_azienda_menu = modulo_azienda.moduli_menu[j];
                      for (
                        let j_s = 0;
                        j_s < modulo.moduli_menu.length;
                        j_s++
                      ) {
                        let modulo_menu = modulo.moduli_menu[j_s];
                        if (modulo_menu.path == modulo_azienda_menu.path) {
                          that.moduli[i_s].moduli_menu[j_s].id_modulo_menu =
                            modulo_azienda_menu.id_modulo_menu;
                          that.moduli[i_s].moduli_menu[j_s].pagina =
                            modulo_azienda_menu.pagina;
                          that.moduli[i_s].moduli_menu[j_s].des =
                            modulo_azienda_menu.des;
                        }
                      }
                    }
                    that.moduli[i_s].moduli_menu.sort(
                      (a, b) => a.pagina - b.pagina
                    );
                  }
                }
              }
              that.moduli.sort((a, b) => a.ordine - b.ordine);
              that.loaded = true;
            } catch (error) {
              console.log(error);
            }
          },
        },
      };
      this.NETWORK.AjaxRequest(request);
    },

    async save() {
      let moduli_tree = [];
      for (
        let index_modulo = 0;
        index_modulo < this.moduli.length;
        index_modulo++
      ) {
        let modulo = JSON.parse(JSON.stringify(this.moduli[index_modulo]));
        modulo.moduli_menu = [];
        modulo.moduli_parametri = [];
        for (
          let index_tree = 0;
          index_tree < this.array_menu_tree.length;
          index_tree++
        ) {
          if (
            this.array_menu_tree[index_tree].length > 0
              ? this.array_menu_tree[index_tree][0].cod_modulo ==
                modulo.cod_modulo
              : false
          ) {
            await this.revertTree(
              this.array_menu_tree[index_tree][0].children,
              modulo
            );
          }
        }
        moduli_tree.push(modulo);
      }

      let moduli = [];
      let moduli_menu = [];
      for (let i = 0; i < moduli_tree.length; i++) {
        let modulo = JSON.parse(JSON.stringify(moduli_tree[i]));
        // modulo.ordine = i;
        modulo.id_azienda = 1;
        for (let j = 0; j < modulo.moduli_menu.length; j++) {
          let modulo_menu = modulo.moduli_menu[j];
          // modulo_menu.pagina = j;
          modulo_menu.index_reference = modulo.cod_modulo;
          moduli_menu.push(modulo_menu);
        }
        delete modulo.moduli_menu;
        moduli.push(modulo);
      }

      let that = this;
      let request = {
        controller: "Modulo",
        body: {
          action: "setModuliAziendaparametri",
          token: localStorage.user_token,
          moduli: moduli,
          moduli_menu: moduli_menu,
          id_azienda: this.azienda_sel,
        },
        method: "PUT",
        on: {
          load: function () {
            that.getModuli();
            that.alert = {
              message: "Dati salvati con successo",
              show: true,
              error: false,
            };
          },
          error: function () {
            that.alert = {
              message: "Errore durante il salvataggio",
              show: true,
              error: true,
            };
          },
        },
      };
      this.NETWORK.AjaxRequest(request);
    },

    nuovo_parametro() {
      //il figlio se il padre è nuovo avrà id_padre = id_temp del padre
      this.template_menu.id_temp = this.template_menu.id_temp
        ? this.template_menu.id_temp
        : -moment().valueOf(); //id_temp nodo padre nuovo anche lui nuovo
      this.template_menu.moduli_menu_parametri.push({
        id_menu_parametro: -1,
        id_modulo_menu: this.template_menu.id_modulo_menu,
        cod_parametro: "",
        val_parametro: "",
        id_temp_padre: this.template_menu.id_temp,
        id_temp: -moment().valueOf(),
        validita: 1,
      });
    },

    deleteItem(associazione) {
      let index = this.template_menu.moduli_menu_parametri.findIndex(
        (item) => item.id_menu_parametro === associazione.id_menu_parametro
      );
      if (
        this.template_menu.moduli_menu_parametri[index].id_menu_parametro != -1
      ) {
        this.template_menu.moduli_menu_parametri[index].validita = 0;
      } else {
        this.template_menu.moduli_menu_parametri.splice(index, 1);
      }
    },
  },

  computed: {
    filteredParametriValidita() {
      return this.template_menu.moduli_menu_parametri.filter((i) => {
        return i.validita === null || i.validita === 1 || i.validita === "";
      });
    },
  },
};
</script>
<style scoped>
.gestione_mod_az {
  width: 100%;
  height: calc(100vh - 48px);
  overflow: hidden;
  position: relative;
  user-select: none;
  white-space: nowrap;
}

.gestione_mod_az > header {
  padding: 0;
  margin: 0;
  height: 100px;
  overflow: hidden;
}

.gestione_mod_az > div {
  position: relative;
  width: 100%;
  height: calc(100% - 100px);
  overflow: auto;
}

#tree_view {
  position: relative;
  display: inline-block;
  vertical-align: top;
  min-width: 400px;
  text-align: left;
  padding: 15px;
  margin: 0 auto;
  transition: margin-left 0.5s linear;
}

#tree_view .tree_section {
  display: block;
  margin-left: 12px;
  margin-bottom: 10px;
}

#tree_view .tree_section > div {
  height: 30px;
  display: block;
  border-radius: 3px;
  padding: 0 5px;
}
#tree_view .tree_section > div:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
#tree_view .tree_section > div > * {
  display: inline-block;
  vertical-align: middle;
}
#tree_view .tree_section > div > .tree_checkbox {
  height: 30px;
  width: 30px;
  margin: 0;
}
#tree_view .tree_section > div > h3 {
  font-weight: bold;
}
#tree_view .tree_section > div > h4 {
  font-weight: normal;
  cursor: grab;
  width: 190px;
}

#tree_view .tree_section > div > *[data-lazy],
#tree_view .tree_section > div > img {
  width: 24px;
  margin: 0 12px 0 0;
}
#tree_view .tree_section > div > *[data-move] {
  float: right;
}
#tree_view .tree_section > div > input {
  outline: none !important;
  border-bottom: 1px solid grey;
  appearance: none;
  border-radius: 0;
  width: 120px;
  margin-left: 10px;
}
</style>
